













import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FHeader'
})
class FHeader extends Vue {
  @Prop() readonly cols?: number
  @Prop() readonly md?: number

  private get columns(): number {
    return this.cols ? this.cols : 8
  }

  private get mdColumns(): number {
    return this.md ? this.md : 10
  }
}

export default FHeader
